import { createSelector, MemoizedSelector } from '@ngrx/store'
import { profileIdentity } from '@se-po/shared-data-access-profile'
import type { ProfileIdentity, ProfileIdentityContext } from '@se-po/shared-data-access-profile'
import { NginAdminManagementSelectors } from 'se-fe-data-access/ngin-admin-management'
import { NginUserPersonaSelectors } from 'se-fe-data-access/ngin-user-persona'
import { UserServicePersonaSelectors } from 'se-fe-data-access/user-service-persona'
import {
  PROFILE_SIDE_PANEL_ADMIN_DETAIL_REQUEST_KEY,
  PROFILE_SIDE_PANEL_PERSONA_DETAIL_REQUEST_KEY,
} from './profile-side-panel-request-keys'

export type {
  ProfileIdentity as ProfileSidePanelModel,
  ProfileIdentityContext as ProfileSidePanelEntityProps,
} from '@se-po/shared-data-access-profile'

export const selectProfileSidePanelAdmin = NginAdminManagementSelectors.selectNginAdminManagement(
  PROFILE_SIDE_PANEL_ADMIN_DETAIL_REQUEST_KEY
)

export const selectProfileSidePanelModel = (
  context: ProfileIdentityContext
): MemoizedSelector<object, ProfileIdentity> => createSelector(
  NginUserPersonaSelectors.selectNginUserPersonaEntities,
  NginUserPersonaSelectors.selectNginUserPersonaLoadStatus(PROFILE_SIDE_PANEL_PERSONA_DETAIL_REQUEST_KEY),
  UserServicePersonaSelectors.selectUserServicePersonaEntities,
  selectProfileSidePanelAdmin,
  NginAdminManagementSelectors.selectNginAdminManagementLoadStatus(PROFILE_SIDE_PANEL_ADMIN_DETAIL_REQUEST_KEY),
  (personas, personaStatus, verifiedPersonas, admin, adminStatus) => {
    const persona = context.personaId ? personas[String(context.personaId)] : undefined
    const verifiedPersona = context.personaId ? verifiedPersonas[String(context.personaId)] : undefined
    return profileIdentity(context, {
      persona,
      verifiedPersona,
      admin,
      headerLoaded: requestResolved(persona, personaStatus) && requestResolved(admin, adminStatus),
    })
  }
)

const requestResolved = (resource: unknown, status: string): boolean =>
  !!resource || status === 'success' || status === 'failure'
